export default {
  parse (error) {
    // console.error(error)
    if (error.response) {
      switch (error.response.status) {
        case 400:
          return Promise.reject(error.response.data)
        case 401:
        case 403:
        case 404:
        case 409:
          return Promise.reject(error.response.status)
      }
    }

    return Promise.reject(new Error(500))
  },
  parseWithRetryWhenConflict(error, attempt, retry) {
    if (error.response && error.response.status === 409 && (attempt || 0) < 2) {
      return retry((attempt || 0) + 1)
    } else {
      return this.parse(error)
    }
  },
  isUserError (error) {
    return Array.isArray(error)
  },
  containsCode (error, code) {
    return error.map(next => next.code).includes(code)
  }
}
